import React from "react";

const DetailsSection = ({ header, children, show = true, classes }: { header: string; children: React.ReactNode; show?: boolean, classes?: string }) => {
  if (!show) return null;
  return (
    <div className={`details-container ${classes || ""}`}>
      <div className="details-container_header">{header}</div>
      <div className="details-container_content">{children}</div>
    </div>
  );
};

export default DetailsSection;